module.exports = __webpack_public_path__ + "static/img/egg_r_17.8731bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_17.png
// module id = LQ5j
// module chunks = 1